import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  MenuItem,
  Avatar,
  Grid,
  CardContent,
  useMediaQuery,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Error,
  Close,
  Email,
  Help,
  WebAsset,
  Timeline,
  Equalizer,
  DirectionsBus,
  Payment
} from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { useSnackbar } from "notistack";

import icon from "../../assets/img/logo_white.svg";
import otpVerification from "../../assets/svg/otpVerification.svg";

import Footer from "./footer.jsx";

import { withLocalize, Translate } from "react-localize-redux";
import { FinanceService } from "../../utils/web_config_2";
import axiosRetry from "axios-retry";

import PinInput from 'react-pin-input'

const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn: {
    textTransform: "capitalize",
  },
}));





function OtpVerification(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [extRefNo, setExtRefNo]=useState("");





  useEffect(() => {
    var refNo = props.match.params.ext_ref_no;
    setExtRefNo(refNo)

  }, []);


  const [isValidating,setIsValidating]=useState(false)
  const [isValidated, setIsValided] = useState(false)

  const validateOtp = (otp) => {
    if (extRefNo!==""){

      console.log(extRefNo)
      setIsValidating(true);

      const request = {
        otp: otp,
        ext_ref_no: extRefNo
      };
      
      const otpValidateInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().OTP_VERIFICATION));
      // const otpValidateInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().TOP_UP_TOKEN_TEST));

      otpValidateInstance.post(new FinanceService().VALIDATE_OPT_PAYMENT,request)

        .then(res => {

          var data = res.data.data;
          if (data.hasOwnProperty("msg_id")){
            enqueueSnackbar("Please wait for confirmation SMS", {
              variant: "success",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
            history.push("/landing") 
            return
          }
          if (data.redirection_link != "" && data.redirection_link != " ") {
            console.log(data.redirection_link + "?status=COMPLETED&message=" + res.data.message);
            // window.location.href = data.url; 
            window.open(data.redirection_link + "?status=COMPLETED&message=" + res.data.message, "_blank")
            window.close();
          } else { 
            history.push("/landing") 
          }

          console.log(data);
          setIsValidating(false);
          setIsValided(true);

        })
        .catch(err => {

          history.push("/landing")

          setIsValidating(false);
          setIsValided(false);

          if (err?.response) {
            console.log("oooook", err?.response?.data)

            if (err?.response?.data?.data?.redirection_link != "" && err?.response?.data?.data.redirection_link != " ") {
              console.log(err?.response?.data?.data.redirection_link);
              // window.location.href = data.url; 
              window.open(err?.response?.data?.data.redirection_link + "?status=FAILED&message=" + err?.response?.data?.message, "_blank")
              window.close();
            }



            enqueueSnackbar(err?.response?.data?.message, {
              variant: "error",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          } else {
            enqueueSnackbar(err?.message, {
              variant: "error",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
          }

        });
    }else{
      // external reference provided
      
    }

   

    
  };



  return (
    <div className={classes.root}>
      <CssBaseline />
     
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar>
          <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>
          <Typography variant="h6" className={classes.title}>
            OTP Verification
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={5}>
          <Box p={2} display="flex" flexDirection="column">
            <img
              src={otpVerification}
              style={{ height: 300 }}
              alt="Cards showcase"
            />
            <Box
              mb={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            ></Box>
            <Typography color="textSecondary" align="center">
              Please enter your OTP , to validate your payment.
            </Typography>
          </Box>
          <Box mt={3} display="flex" justifyContent="center" >

            {!isValidating&&<PinInput
              length={6}
            initialValue=""
            secret
            focus
            onChange={() => { }}
            type="numeric"
            inputMode="number"
            style={{ padding: '10px', borderRadius: "7px" }}
            inputStyle={{ borderColor: theme.palette.secondary.main }}
            inputFocusStyle={{ borderColor: theme.palette.primary.main }}
            onComplete={(value, index) => { validateOtp(value) }}
            autoSelect={false}
            />}
            {isValidating && <CircularProgress />}

          </Box>

        </Box>
      </Container>
      <Container maxWidth="lg">
        <Grid container justify="center" alignContent="center" >
          <Grid item xs={12} sm={4} md={3} >
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2} mt={8}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2} mt={8}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2} mt={8}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
}

export default withLocalize(OtpVerification);
